import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import PWAPrompt from 'react-ios-pwa-prompt';
import App from './App';
import * as serviceWorker from './serviceWorker';
import './css/index.css';

ReactDOM.render(
  <React.StrictMode>
  	<Router>
      <App />
    </Router>
    <PWAPrompt />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();